import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MaintenanceService } from '../maintenance/maintenance.service';
import { LogUpdateService } from '../service-worker';

@Component({
  selector: 'hb-app-update-notice',
  imports: [MatButtonModule],
  templateUrl: './app-update-notice.component.html',
  styleUrl: './app-update-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppUpdateNoticeComponent {
  readonly updates = inject(LogUpdateService);
  private readonly maintenance = inject(MaintenanceService);
  readonly visible = computed(
    () =>
      this.updates.updateAvailable() && !this.maintenance.blocked() && this.maintenance.state().mode !== 'connection'
  );
}
